var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses,style:({maxHeight: _vm.maxHeight})},[_c(_vm.tag,{tag:"component",class:_vm.tableClasses,style:(_vm.tableStyle)},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }